import { BLOG_API } from '@common/consts';

const URL = {
  GET_SALE_COIN_LIST: '/v2/asset/transaction/public/currencies',
  GET_ASSET_OVERVIEW: '/v2/asset/accounts/asset-overview',
  GET_CHART: '/v2/asset/transaction/public/chart',
  GET_ARTICLES: '/v2/support/article/page/article',
  GET_ARTICLE: '/v2/support/article',
  GET_BLOG: `${BLOG_API}/posts?categories=72&per_page=1&_embed`,
  GET_BANNER_LIST: '/v2/support/home/news/web/banner/list',
  GET_CURRENCY_INFO: '/v2/asset/currency/detail',

  GET_STAKING_CURRENCY: '/v2/asset/earn/public/projects?type=1',
  GET_KYC_STATUS: '/v3/users/security/profile',
  GET_RECURRING_HISTORY: '/v2/asset/transaction/plan/userHasPlan',
  GET_RECURRING_LiST:
    '/v2/asset/transaction/public/currencies?checkOnline=true&dynamicQuotePrecision=true',
  SUBMIT_RECRUIT: '/v2/support/recruitment/applyJob',
};
export default URL;
